import { z, isoZ } from 'my-zod'
import { ActionPlanTaskStatusTypeEnum } from './action-plan-enums'

const taskGroupFragment = z.object({
  id: z.number(),
  actionPlanId: z.number(),
  orderInActionPlan: z.number(),
  title: z.string().nullable(),
  createdDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

const taskFragment = z.object({
  id: z.number(),
  shortId: z.string(),
  actionPlanId: z.number().nullable().setLabel('Action Plan'),
  groupId: z.number().nullable(),
  orderInGroup: z.number().nullable(),
  assigneeUserId: z.number().setLabel('Task Owner'),
  outfitterId: z.number().nullable().setLabel('Outfitter'),
  title: z.string().max(50).nonempty().setLabel('Task Name'),
  dueDate: isoZ.date().setLabel('Due Date'),
  notes: z.string().nullable().setLabel('Notes'),
  status: ActionPlanTaskStatusTypeEnum.setLabel('Status'),
  lastModifiedByUserId: z.number(),
  lastModifiedDate: isoZ.instant(),
  createdDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable()
})

export const actionPlanTaskGroupModel = taskGroupFragment

export type actionPlanTaskGroupModel = z.infer<typeof actionPlanTaskGroupModel>

export const actionPlanTaskModel = taskFragment

export type actionPlanTaskModel = z.infer<typeof actionPlanTaskModel>
